import React from 'react';
import { Form, Button } from 'semantic-ui-react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from 'components/loaders/Loader';
import { useBookingHistoryContext } from '../BookingHistory/BookingHistoryContext';
import styles from './styles.module.scss';
import { downloadCsv } from './utils';

const MonthPickerButton = React.forwardRef(({ value, onClick }, ref) => (
  <button
    type="button"
    className={styles.datePickerButton}
    onClick={onClick}
    ref={ref}
  >
    {value}
  </button>
));

export const BookingHistoryFiltersAndExport = () => {
  const {
    bookingHistory,
    selectedDate,
    setSelectedDate,
    selectedResourceType,
    setSelectedResourceType,
    isFetching,
  } = useBookingHistoryContext();

  const intl = useIntl();

  if (isFetching) return <Loader />;

  const resourceTypeOptions = [
    { key: 'all', value: '', text: intl.formatMessage({ id: 'allResourceTypes' }) },
    { key: 'laundry', value: 'Laundry', text: intl.formatMessage({ id: 'laundry' }) },
    { key: 'apartment', value: 'Apartment', text: intl.formatMessage({ id: 'apartment' }) },
  ];

  return (
    <>
      <div className={styles.filters}>
        <Form.Group className={styles.fields}>
          <Form.Field className={styles.field}>
            <label>
              <FormattedMessage id="selectMonth" />
            </label>
            <ReactDatePicker
              selected={selectedDate}
              minDate={new Date('2026-07-01')} //no booking history is available before this date
              maxDate={new Date()}
              onChange={(date) => setSelectedDate(date || new Date())}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              locale={intl.locale}
              customInput={<MonthPickerButton />}
              renderMonthContent={(month, shortMonth, day, date) => {
                const fullYear = new Date(date).getFullYear();
                const formattedMonth = new Date(`${fullYear}-${month}-1`);

                const isBeforeJuly2026 = formattedMonth < new Date('2026-07-01');
                const noBookingHistory = isBeforeJuly2026 ? intl.formatMessage({
                  id: 'noBookingHistory',
                }) : '';

                return (
                  <span title={noBookingHistory}>{shortMonth}</span>
                );
              }}
            />
          </Form.Field>

          <Form.Field className={styles.field}>
            <label>
              <FormattedMessage id="resourceType" />
            </label>
            <div className={styles.resourceTypeToggle}>
              {resourceTypeOptions.map((option) => {
                const isActive = selectedResourceType === option.value;

                return (
                  <Button
                    key={option.key}
                    type="button"
                    size="small"
                    basic={!isActive}
                    onClick={() => setSelectedResourceType(option.value)}
                  >
                    {option.text}
                  </Button>
                );
              })}
            </div>
          </Form.Field>
        </Form.Group>
      </div>

      <div className={styles.actions}>
        <Button
          type="button"
          onClick={() => downloadCsv(intl, bookingHistory)}
        >
          <FormattedMessage id="exportCsv" />
        </Button>
      </div>
    </>
  );
};
